import covid19VaccineCardScenario from 'garaje/mirage/scenarios/covid19-vaccine-card';
import covid19TestResultScenario from 'garaje/mirage/scenarios/covid19-test-result';
import { faker } from '@faker-js/faker';

/**
 * @param {object} server Mirage Server
 */
export default function (server) {
  covid19VaccineCardScenario(server);
  covid19TestResultScenario(server);

  server.create('user-document', 'asCovidVaccineCard', 'withAttachments', 'asReview');

  server.create(
    'user-document',
    { createdAt: faker.date.recent() },
    'asCovidTestResult',
    'withAttachments',
    'asReview'
  );

  server.create(
    'user-document',
    { createdAt: faker.date.past() },
    'asCovidTestResult',
    'withAttachments',
    'asApproved'
  );
  server.create('user-document', { createdAt: faker.date.past() }, 'asCovidTestResult', 'withAttachments', 'asDenied');

  server.create(
    'user-document',
    { createdAt: faker.date.past() },
    'asCovidTestResult',
    'withAttachments',
    'asApproved'
  );

  server.create(
    'user-document',
    { createdAt: faker.date.past() },
    'asCovidTestResult',
    'withAttachments',
    'asApproved'
  );
}
